<template>
    <span class="arrow pointer" data-direction="direction" @click="changeDate(amount)">
        <span :class="['ico-arrow-' + direction]"></span>
    </span>
</template>

<script>
    import $ from 'jquery'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        props: {
            amount: String,
            direction: String
        },
        computed: {
            ...mapGetters([
                'getExpandedDay',
                'getCurrentView',
            ])
        },
        methods: {
            ...mapActions([
                'updateExpandedDate',
                'updateSidebar'
            ]),

            // Increments / decrements the currently selected date

            changeDate: function(amount) {
                var cal = $('#calendar');
                var oldDate = this.getExpandedDay;
                //this allows to add 1 month when in month view
                if(this.getCurrentView == 'month'){
                    var newDate = this.formatDate(moment(this.getExpandedDay).add(this.amount, 'months'));
                } else if (this.getCurrentView == 'agendaWeek'){
                    var newDate = this.formatDate(moment(this.getExpandedDay).add(this.amount, 'weeks'));
                } else {
                    var newDate = this.formatDate(moment(this.getExpandedDay).add(this.amount, 'days'));
                }

                this.updateExpandedDate(newDate);

                // Workaround: add 100 days to reset the amount of days in cache
                // More info: https://github.com/fullcalendar/fullcalendar-scheduler/issues/237

                //cal.fullCalendar('incrementDate', { days: 100 });
                //cal.fullCalendar('incrementDate', { days: -100 });
                cal.fullCalendar('gotoDate', newDate);

                this.updateSidebar(newDate);

                // Trigger an update on the events list in case we don't have the selected day filled with
                // data from the API

                //this.$emit('updateArrowDate', { oldDate: oldDate, newDate: newDate });

                // Push new route parameters
                let viewToURL = '';
                switch (this.getCurrentView) {
                    case 'agendaDay':
                        viewToURL = 'day'
                        break;
                    case 'agendaWeek':
                        viewToURL = 'week'
                        break;
                    default:
                    viewToURL = this.getCurrentView;
                }

                this.$router.push({ name: 'calendarExpanded', params: { currentView: viewToURL, expandedDay: newDate } });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Arrow.vue?110f785a